import { Injectable, OnDestroy } from '@angular/core';
import { environment } from 'projects/shared/environments/environment';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { Observable, BehaviorSubject, Subject, takeUntil, tap, noop } from 'rxjs';
import { io, Socket } from 'socket.io-client';

interface SocketQueryParams {
  userId: string;
  [key: string]: string | undefined;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationSocketService {
  private baseURL = `${environment.apiUrl.replace('v1/', '')}`

  private readonly BASE_URL = `${this.baseURL}notifications`;
  private socket!: Socket;
  newNotification = new BehaviorSubject<any>({})
  private nameSpace = 'notifications'
  constructor(private _storeChangesService: StoreChangesService) {
  }

  initSocket(userId: string): void {
    // Prevent multiple initializations
    if (this.socket) {
      return;
    }
    this.socket = io(`${this.BASE_URL}`, {
      transports: ['websocket'],
      query: { userId },
    });
    this.onSocketConnect(userId)
  }


  onSocketConnect(userId: string) {
    if (this.socket) this.socket.on('connect', () => {
      this.joinToRoom('joinRoom', userId);
    });
  }

  joinToRoom(room: string, userId: string) {
    if (this.socket) {
      this.socket.emit(room, userId);
    }
    else return;
    this.onNewNotification();

  }
  onNewNotification() {
    if (this.socket) this.socket.on('newNotification', data => {
      this.newNotification.next(data);
    })
  }



}